export function checkInfiniteItemsFetchDataIsLastPage(response, getDataItems) {
  if (getDataItems(response).length === 0) {
    return true
  }

  if (
    Number.isSafeInteger(response.meta?.page_count) &&
    Number.isSafeInteger(response.meta?.curr_page)
  ) {
    return response.meta.page_count === response.meta.curr_page
  }

  if (
    Number.isSafeInteger(response.data.meta?.page_count) &&
    Number.isSafeInteger(response.data.meta?.curr_page)
  ) {
    return response.data.meta?.page_count === response.data.meta?.curr_page
  }

  if (
    Number.isSafeInteger(response.data.pagination?.page_count) &&
    Number.isSafeInteger(response.data.pagination?.page)
  ) {
    return response.data.pagination.page_count === response.data.pagination.page
  }

  if (
    Number.isSafeInteger(response.data.pages) &&
    Number.isSafeInteger(response.data.curr_page)
  ) {
    return response.data.pages === response.data.curr_page
  }

  return false
}

export function appendItems(prevItems, nextItems) {
  return [...prevItems, ...nextItems]
}

export function getPermissions({ data }) {
  return data.permissions
}

export function getPreparedItems(items) {
  return items
}

// A load superseded by a newer initial one, or answered after the unmount,
// must not touch the list.
export function isInfiniteItemsLoadCurrent({
  generation,
  isMountedRef,
  loadGenerationRef,
}) {
  return (
    isMountedRef.current !== false && generation === loadGenerationRef.current
  )
}

export function getTotalItemsCountData(response) {
  return (
    response.data.pagination?.total ??
    response.data.meta?.count ??
    response.data.count ??
    response.meta?.count ??
    0
  )
}
